/** Filename from Content-Disposition header (shared by Support, Insights, etc.). */
export const parseFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return 'downloaded-file'
  return contentDisposition.split('filename=')[1].split(';')[0].replace(/"/g, '')
}

/** Extension → MIME for preview blob (shared by Support, Insights). */
export const EXTENSION_TO_MIME_TYPE = Object.freeze({
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  bmp: 'image/bmp',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  odt: 'application/vnd.oasis.opendocument.text',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  rtf: 'application/rtf',
  txt: 'text/plain',
  csv: 'text/csv',
})
